import { type DatiProcura } from '@framework/api-client/api/inquiries-compile/schemas/datiProcura.ts';
import { getContextFileNameField } from '../../widgets/upload/UploadWidget.type.tsx';

export const attorneyDocumentContextField = 'attorneyDocument';

export function mapAttorneyToContext(
  attorney: DatiProcura | null | undefined,
): Record<string, any> {
  return {
    codiceFiscale: attorney?.codiceFiscale,
    nome: attorney?.nome,
    cognome: attorney?.cognome,
    email: attorney?.email,
    // Usiamo questo nome per il campo del documento di procura
    // per la gestione speciale della reference come valore di default per
    // i widget di tipo upload.
    [attorneyDocumentContextField]: attorney?.idFile,
    [getContextFileNameField(attorneyDocumentContextField)]: attorney?.nomeFile,
  };
}
